import React from 'react';
import { Button, FormGroup, Label, Input } from '../../../components/Bootstrap';
import { NobleModal } from '../../../components';

interface ServerModalProps {
  isOpen: boolean;
  toggle();
  serverName: string;
  onChange(event);
  onSubmit(event);
  title: string;
}

export class ServerModal extends React.Component<ServerModalProps> {
  render() {
    const { isOpen, toggle, serverName, title, onChange, onSubmit } = this.props;

    return (
      <NobleModal isOpen={isOpen} toggle={toggle}>
        <NobleModal.Title title={title} />
        <NobleModal.Body>
          <div className='delivery-assignments-content'>
            <FormGroup>
              <Label for='option'>Server's Name</Label>
              <Input value={serverName} onChange={onChange} id='price' placeholder='Drew Pomerleau' />
            </FormGroup>
            <div className='text-center mt-4'>
              <Button type='button' color='link' onClick={toggle}>
                Cancel
              </Button>{' '}
              <Button color='primary' onClick={onSubmit}>
                Save
              </Button>
            </div>
          </div>
        </NobleModal.Body>
      </NobleModal>
    );
  }
}
